import {
  makeStyles,
  tokens,
  shorthands,
} from '@fluentui/react-components';

export const useStepProgressListStyle = makeStyles({
  // Common styles
  stepListItem: {
    display: 'flex',
    alignItems: 'center',
    '&:focus': {
      ...shorthands.outline('1px solid'),
    },
  },
  stepListItemDivider: {
    '&:before, &:after': {
      ...shorthands.borderColor(tokens.colorNeutralStroke1),
    },
  },
  stepListItemContent: {
    position: 'relative',
  },
  stepListItemIcon: {
    '& svg': {
      width: '18px',
      height: '18px',
    },
    color: tokens.colorNeutralForeground2,
  },
  stepListItemTitle: {
    lineHeight: '18px',
    color: tokens.colorNeutralForeground1,
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    ...shorthands.overflow('hidden'),
  },
  stepListItemDetail: {
    fontSize: '12px',
    lineHeight: '16px',
    color: tokens.colorNeutralForeground4,
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    ...shorthands.overflow('hidden'),
    ...shorthands.margin('2px', '0px', '0px', '0px'),
  },

  // step item has status
  // sub step
  stepListItemIconSubStep: {
    '& svg': {
      width: '14px',
      height: '14px',
    },
  },
  stepListItemTitleSubStep: {
    fontSize: '10px',
    lineHeight: '14px',
  },
  stepListItemDetailSubStep: {
    fontSize: '10px',
    lineHeight: '14px',
  },

  // behind
  stepListItemDividerBehind: {
    '&:before, &:after': {
      ...shorthands.borderColor(tokens.colorNeutralForeground2BrandSelected),
    },
  },
  stepListItemIconBehind: {
    color: tokens.colorNeutralForeground2BrandSelected,
  },

  // selected
  stepListItemIconSelected: {
    color: tokens.colorNeutralForeground2BrandSelected,
  },

  // error
  stepListItemDividerError: {
    '&:before, &:after': {
      ...shorthands.borderColor(tokens.colorNeutralStroke1),
    },
  },
  stepListItemIconError: {
    color: tokens.colorStatusDangerBackground3,
  },

  // Vertical styles
  listContainerVertical: {
    height: '100%',
    width: 'fit-content',
    backgroundColor: tokens.colorNeutralBackground3,
    ...shorthands.padding('24px', '170px', '24px', '24px'),
    ...shorthands.borderRight('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.overflow('hidden', 'auto'),
    '& .step-list-item:last-child': {
      '& .step-list-item-divider': {
        display: 'none',
      },
    },
  },
  stepListItemVertical: {
    flexDirection: 'column',
  },
  stepListItemDividerVertical: {
    height: '40px',
  },
  stepListItemIconVertical: {
    ...shorthands.margin('6px', '2px'),
  },
  stepListItemTitleContainerVertical: {
    position: 'absolute',
    left: '20px',
    top: '5.5px',
    width: 'max-content',
    maxWidth: '165px',
    ...shorthands.padding('0px', '10px'),
  },
  stepListItemTitleVertical: {
    WebkitLineClamp: 2,
  },
  stepListItemTitleContainerSubStepVertical: {
    top: '7px',
  },
  // responsive vertical styles
  stepListItemTitleContainerCollapsed: {
    display: 'none',
  },
  listContainerCollapsed: {
    ...shorthands.padding('24px', '24px', '0px'),
    '&:hover': {
      ...shorthands.padding('24px', '170px', '0px', '24px'),
      '& .step-list-item-title-container': {
        display: 'inline',
      },
    },
  },

  // Horizontal styles
  listContainerHorizontal: {
    width: '100%',
    minHeight: 'fit-content',
    backgroundColor: tokens.colorNeutralBackground3,
    display: 'flex',
    flexDirection: 'row',
    ...shorthands.borderBottom('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.padding('24px', '16px', '60px'),
    ...shorthands.overflow('auto'),
    '& .step-list-item:last-child': {
      width: 'auto',
      '& .step-list-item-divider': {
        display: 'none',
      },
    },
  },
  stepListItemHorizontal: {
    flexDirection: 'row',
  },

  stepListItemDividerHorizontal: {
    width: '96px',
  },

  stepListItemIconHorizontal: {
    ...shorthands.margin('6px', '4px'),
  },
  stepListItemTitleContainerHorizontal: {
    position: 'absolute',
    top: '28px',
    left: '6px',
    width: 'max-content',
    maxWidth: '100px',
  },
  stepListItemTitleHorizontal: {
    WebkitLineClamp: 1,
  },
  stepListItemTitleContainerSubStepHorizontal: {
    top: '30px',
  },
});
